export default __webpack_public_path__ + "static/media/layingTurf.bff4cf90.jpg";